const map = {
	"./ar.png": 18306,
	"./bn.png": 41963,
	"./ca.png": 44483,
	"./de.png": 90042,
	"./en.png": 54818,
	"./es.png": 85543,
	"./fr.png": 19891,
	"./he.png": 81742,
	"./hi.png": 57570,
	"./it.png": 16796,
	"./ja.png": 94788,
	"./ko.png": 82501,
	"./no.png": 39630,
	"./pt.png": 77839,
	"./ru.png": 68824,
	"./sk.png": 27417,
	"./sv.png": 17228,
	"./vi.png": 49648,
	"./zh.png": 34853
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16120;